/* eslint-disabled */

export default class WhatsappTemplateExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
